// Purchase Order
const POIndex = () => import("./purchase-order/index.vue");
const CreatePO = () => import("./purchase-order/_pages/create.vue");
const PODetails = () => import("./purchase-order/_pages/view.vue");
// cargo
const CargoIndex = () => import("./cargo-delivery/index.vue");
const CargoCreate = () => import("./cargo-delivery/_pages/create.vue");
const CargoDetails = () => import("./cargo-delivery/_pages/view.vue");

// Goods Receipt
const GoodsReceiptIndex = () => import("./goods-receipt/index.vue");
const CreateGoodsReceipt = () => import("./goods-receipt/_pages/create.vue");
const GoodsReceiptDetails = () => import("./goods-receipt/_pages/view.vue");
const GoodsReceiptCopy = () => import("./goods-receipt/_pages/copy.vue");

// Goods Receipt
const DocumentDrafttIndex = () => import("./document-drafts/index.vue");

// stock take 
const StockTakeIndex = () => import("./stock-take/index.vue");
const CreateStockTake = () => import("./stock-take/_pages/create.vue");
const StockTakeView = () => import("./stock-take/_pages/view.vue");

const ImportPurchase = () =>
  import("./goods-receipt/_pages/import-purchase.vue");

const ImeiDetails = () => import("./goods-receipt/_pages/imei.vue");
const AddGeneralImeis = () => import("./add-general-imeis.vue");

export default [
  {
    path: "/add-general-imeis",
    component: AddGeneralImeis,
  },
  {
    path: "/stock-take",
    component: StockTakeIndex,
  },
  {
    path: "/new-stock-take",
    component: CreateStockTake,
  },
  {
    path: "/stock-take/:id",
    component: StockTakeView,
  },
  {
    path: "/purchase-orders",
    component: POIndex,
  },
  {
    path: "/new-purchase-order",
    component: CreatePO,
  },
  {
    path: "/purchase-orders/:id",
    component: PODetails,
  },
  {
    path: "/device-imeis/:id",
    component: ImeiDetails,
  },
  {
    path: "/import-purchase",
    component: ImportPurchase,
  },
  {
    path: "/cargo/delivery",
    component: CargoIndex,
  },
  {
    path: "/new-cargo-delivery",
    component: CargoCreate,
  },
  {
    path: "/cargo-delivery/:id",
    component: CargoDetails,
  },
  {
    path: "/goods-receipt",
    component: GoodsReceiptIndex,
  },
  {
    path: "/new-goods-receipt",
    name: "NewGoodsReceipt",
    component: CreateGoodsReceipt,
  },
  {
    path: "/goods-receipt/:id",
    name: "GoodsReceiptDetails",
    component: GoodsReceiptDetails,
  },
  {
    path: "/goods-receipt/:BaseType/:BaseEntry",
    name: "GoodsReceiptCopy",
    component: GoodsReceiptCopy,
  },

  {
    path: "/purchase/drafts",
    name: "PurchaseDrafts",
    component: DocumentDrafttIndex,
  },
];
